// import axios from '@/utils/request'
import request from "../utils/request";

class orderApi {
  //获取快递列表
  static getExpress() {
    return request.get('/cz-goods/v1/public/express')
  }

  //获取订单退回列表
  static getOrderReturnList(params) {
    return request.get('/cz-order/v1/orderReturn',{params:params})
  }

  //获取订单退回详情
  static getOrderReturnDetail(params) {
    return request.get('/cz-order/v1/orderReturn/'+params)
  }
	
  //检测用户当前是否可以换包
  static isShiftBag(params) {
    return request.get('/cz-order/v1/orders/check/swap')
  }
  
  //获取当前正在背的包
  static getCurrentBag() {
    return request.get('/cz-order/v1/orders/preview/product/now')
  }

  //创建退回订单
  static createReturnOrder(data) {
    return request.post('/cz-order/v1/orderReturn',data)
  }

  //更新退回信息
  static updateExpress(data) {
    return request.put('/cz-order/v1/orderReturn/express',data)
  }

  // 获取我拥有的包列表
  static getMyOrderList(params){
    return request.get('/cz-order/v1/orders/myOrder',{params:params})
  }

  //检测商品是否可以换背
  static checkChangeBagService(params){
    return request.get('/cz-order/v1/orders/check/'+params)
  }




  //获取我背过得包
  static getPastOrderList(params){
    return request.get('/cz-order/v1/orders/pastOrder',{params:params})
  }

  //获取订单详情
  static getOrderDetail(params){
    return request.get('/cz-order/v1/orders/detail',{params:params})
  }

  //确认收货
  static confirmReceive(data){
    return request.put('/cz-order/v1/orders/confirm',data)
  }

  //取消订单
  static cancelOrder(data){
    return request.put('/cz-order/v1/orders/cancel',data)
  }

  //确认买断
  static confirmBuyOut(options){
    return request.put('/cz-order/v1/orderItems/buyout/'+options)
  }

  //获取鉴定报告详情
  static getIdentificationDetail(options){
    return request.get('/cz-order/v1/orderReturn/evaluates/'+options)
  }




}

export default orderApi;
